import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { of, retry, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  private isOnline: boolean = navigator.onLine;

  constructor(
    private readonly ngZone: NgZone
  ) {
    window.addEventListener('online', this.updateOnlineStatus.bind(this));
    window.addEventListener('offline', this.updateOnlineStatus.bind(this));
  }

  private updateOnlineStatus() {
    this.ngZone.run(() => {
      this.isOnline = navigator.onLine;
    });
  }

  public navigateWhenOnline(navigationUrl: any[]) {
    // console.log('Network status changed. Online: ', this.isOnline);
    if (this.isOnline) {
      this.navigateWithRetry(navigationUrl);
    }
  }

  get isNetworkOnline(): boolean {
    return this.isOnline;
  }

  protected setLocationHref(url: string) {
    window.location.href = url;
  }

  navigateWithRetry(navigationUrl: any[], attempts: number = 3, delay: number = 1000) {
    return of(null).pipe(
      switchMap(() => {
        this.setLocationHref(`${window.location.origin}${navigationUrl[0]}`);
        return of(null); // so observable continues
      }),
      retry({
        count: attempts,
        delay: delay
      })
    ).subscribe({
      next: () => {
        // console.log('Navigation successful for:', navigationUrl[0]);
      },
      error: (err) => {
        console.error(`Navigation failed after multiple retries for ${navigationUrl[0]}`, err);
      }
    });
  }
}